export const getLevelColor = (level) => ({
  spark: 'bg-orange-100 text-orange-600',
  depth: 'bg-orange-200 text-orange-700',
  breakthrough: 'bg-orange-300 text-orange-800',
}[level] || '');

export const LEVELS = ['spark', 'depth', 'breakthrough'];
